import BtnWhatsapp from "../btnWhatsapp/BtnWhatsapp";
import Footer from "../footer/Footer";
import Nav from "../nav/Nav";
import "./QuienesSomos.css";

const PoliticaDevolucion = () => {
  return (
    <>
      <Nav />
      <div className="quienes-somos">
        <h2>Política de Devolución – TecniPlus+</h2>
        <p>
          En TecniPlus+ trabajamos para brindarte un servicio técnico confiable
          y de calidad. Debido a la naturaleza de las reparaciones, nuestra
          política de devolución se detalla a continuación:
        </p>
        <p>
          1. Servicios realizados Una vez finalizada la reparación y entregado
          el equipo, no se realizan devoluciones del importe abonado por el
          servicio técnico, ya que el trabajo fue efectuado sobre el
          dispositivo.
        </p>
        <p>
          2. Garantía del servicio Ofrecemos una garantía limitada sobre las
          reparaciones realizadas, que cubre únicamente fallas relacionadas con
          el trabajo efectuado o con el repuesto instalado. La duración de la
          garantía será informada al momento de la entrega.
        </p>
        <p>
          3. Garantía en pantallas La garantía en cambios de pantalla aplica
          únicamente para pantallas OLED y originales. Las pantallas Incell no
          cuentan con garantía, sin excepción.
        </p>
        <p>
          4. Exclusiones de garantía La garantía no cubre: <br /> Golpes, caídas
          o daños por mal uso. <br /> Daños por contacto con líquidos. <br />{" "}
          Problemas no relacionados con la reparación realizada. <br /> Equipos
          previamente manipulados por terceros luego de la reparación.
        </p>
        <p>
          {" "}
          5. Equipos no reparables En caso de que el equipo no pueda ser
          reparado, se informará previamente. El diagnóstico puede tener un
          costo, el cual será comunicado antes de proceder.
        </p>
        <p>
          6. Conformidad del cliente Al retirar el equipo, el cliente deberá
          verificar su correcto funcionamiento. Una vez retirado, se entiende
          que el servicio fue aceptado en conformidad.
        </p>
        <p>
          7. Revisión por garantía Si el equipo presenta una falla dentro del
          período de garantía, deberá ser evaluado por nuestro servicio técnico
          para determinar si corresponde la cobertura.
        </p>
        <p>
          En TecniPlus+, nos comprometemos a brindarte soluciones claras,
          honestas y profesionales en cada reparación.
        </p>
      </div>
      <Footer />
      <BtnWhatsapp />
    </>
  );
};

export default PoliticaDevolucion;
